import React from 'react';
import { useHistory } from 'react-router-dom';
import { IVisitorAgreementFormValues } from '../form';
import { Container } from 'react-bootstrap';
import { FormHeading } from '../../../form/formHeading';
import { Form, Well } from '../../../form';
import VisitorAgreementDetailsForm from '../form';
import createVisitorAgreement from './createVisitorAgreement';
import schema from '../form/schema';

const initialValues: IVisitorAgreementFormValues = {
  name: '',
  content: '',
  useDigitalSignature: true,
};

export const CreateVisitorAgreementPage: React.FC = () => {
  const history = useHistory();

  return (
    <Container fluid>
      <Well>
        <FormHeading
          title="Visitor Agreement"
          subTitle="Create"
          backPath="/admin/visitorAgreements"
        />
        <Form
          initialValues={initialValues}
          promise={createVisitorAgreement}
          validationSchema={schema}
          onSubmit={() => history.push('/admin/visitorAgreements')}
        >
          <VisitorAgreementDetailsForm createMode />
        </Form>
      </Well>
    </Container>
  );
};
